<template>
  <div class="x-tablelist-view" data-automation="groupManage">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @change="change"
      @search="seach"
      @input="seach"
      @add="addAPI"
      @import="addSwagger"
      @resetsearch="resetsearch"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        :emptyText="$t('HT.nodata')"
        @changeSize="changeSize"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>
<script>
import bindAccess from './template/bindAccess';
import bindFlow from './template/bindFlowApi';
import release from './template/release';
export default {
  components: {
    bindAccess,
    bindFlow,
    release
  },
  data() {
    return {
      layout: [
        // 搜索项配置
        {
          type: 'select',
          options: [],
          key: 'group',
          placeholder: this.$t('HT.api.type'),
          event: 'change',
          props: {
            label: 'name',
            value: 'id'
          }
        },
        {
          type: 'input',
          key: 'name',
          placeholder: this.$t('HT.apiList.name.placeholder')
        },
        {
          type: 'button',
          text: this.$t('HT.reset'),
          plain: true,
          event: 'resetsearch'
        },
        {
          type: 'button',
          text: this.$t('HT.add'),
          icon: 'ux_icon_plus',
          hidden: !this.$hasModule(12),
          right: true,
          event: 'add'
        },
        {
          type: 'button',
          text: this.$t('HT.router.swagger'),
          hidden: !this.$hasModule(12),
          event: 'import',
          left: true
        }
      ],
      columns: [
        // 表头数据
        {
          label: this.$t('HT.apiStepOne.name'),
          tooltip: true,
          prop: 'name',
          align: 'left',
          render: (h, params) => {
            return h(
              'span',
              {
                class: ['x-table-blue-btn'],
                on: {
                  click: () => {
                    this.$router.push(`/apiInfo/${params.id}`);
                  }
                }
              },
              params.name
            );
          }
        },
        {
          label: this.$t('HT.apiStepOne.remark'),
          prop: 'remark',
          align: 'left',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            return cellValue || '--';
          }
        },
        {
          label: this.$t('HT.apiStepOne.groupId'),
          prop: 'group_id',
          tooltip: true,
          align: 'left',
          formatter: (row, column, cellValue) => {
            return this.$opt.switchStr(cellValue, this.groupList, 'id', 'name');
          }
        },
        {
          label: this.$t('HT.apiList.env'),
          tooltip: true,
          align: 'left',
          render: (h, params) => {
            return h('my-table-tag', {
              props: {
                data: params.states
              }
            });
          }
        },
        {
          label: this.$t('HT.operation'),
          align: 'left',
          hidden: !this.$hasModule(12),
          width: 250,
          render: (h, params) => {
            return h(
              'div',
              {
                attrs: {
                  style: 'overflow:'
                }
              },
              [
                h(
                  'ux-button',
                  {
                    props: {
                      type: 'primary',
                      text: true
                    },
                    attrs: {
                      style: 'margin-right: 10px'
                    },
                    on: {
                      click: () => {
                        this.$router.push({
                          name: 'addApi',
                          query: {
                            id: params.id,
                            tab: 0
                          }
                        });
                      }
                    }
                  },
                  this.$t('HT.edit')
                ),
                h(
                  'ux-button',
                  {
                    props: {
                      type: 'primary',
                      text: true
                    },
                    attrs: {
                      style: 'margin-right: 10px'
                    },
                    on: {
                      click: () => {
                        this.apiDeBugging(params);
                      }
                    }
                  },
                  this.$t('HT.debug')
                ),
                h('moreDropdown', {
                  props: {
                    list: [
                      {
                        label: this.$t('HT.publish'),
                        disabled: params.published == 1 || params.published == 2,
                        event: 'release'
                      },
                      {
                        label: this.$t('HT.soldOut'),
                        disabled: params.published == 0,
                        event: 'offline'
                      },
                      {
                        label: this.$t('HT.delete'),
                        divided: true,
                        event: 'del'
                      }
                    ],
                    text: this.$t('HT.more')
                  },
                  on: {
                    clickItem: (method) => {
                      console.log(method);
                      if (method === 'del') {
                        const title = this.$t('HT.accessInfo.delApi');
                        const content = this.$t('HT.accessInfo.delApi.placeholder');
                        this.$uxModal.show({
                          title,
                          content,
                          confirm: () => {
                            if (params.states.length) {
                              this.$uxModal.hide();
                              this.$uxMessage.error(this.$t('HT.apiList.del.error'));
                            } else {
                              this.delList(params.id);
                            }
                          }
                        });
                      } else if (method == 'apiDeBugging') {
                        this.apiDeBugging(params);
                      } else {
                        method && this.showRelease(method, params);
                      }
                    }
                  }
                })
              ]
            );
          }
        }
      ],
      filter: {
        // 查询参数
        group: '', // 分组
        name: '', // API名称
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      },
      groupList: [], // 分组列表
      accessList: [] // 访问策略
    };
  },
  created() {
    this.getList(this.filter);
    this.getGroupList();
  },
  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.api.getList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },
    /**
     * 重置搜索项
     */
    resetsearch() {
      console.log('重置');
      this.filter.group = '';
      this.filter.name = '';
      this.seach();
    },

    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getGroupList() {
      this.$api.group.getList().then((res) => {
        if (res.code == 10000) {
          this.groupList = this.layout[0]['options'] = res.data;
        }
      });
    },

    /**
     * 删除列表
     * @param {String} id 唯一标识
     */
    delList(id) {
      this.$uxLoading.show();
      this.$api.api.delList(id).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
          if (this.tableData.list.length === 1) {
            this.filter.page = this.filter.page - 1 ? this.filter.page - 1 : 1;
          }
          this.getList(this.filter);
        }
      });
    },

    /**
     * 方法
     * @param {Object} params 跳转到调试页面
     */
    apiDeBugging(debugData) {
      this.$router.push({
        name: 'debug3',
        query: {
          params: JSON.stringify(debugData),
          apiFlag: true
        }
      });
    },

    /**
     * 跳转添加页面
     */
    addAPI() {
      this.$router.push('/addApi');
    },

    /**
     * 跳转swagger导入页面
     */
    addSwagger() {
      this.$router.push('/swagger');
    },

    /**
     * 发布下线弹窗
     * @param {String} type 判断发布与下线
     * @param {Object} params 表格单个对象
     */
    showRelease(type, params) {
      let content =
        type === 'release' ? this.$t('HT.apiList.publishApi') : this.$t('HT.apiList.soldOutApi');
      this.$uxModal.show({
        title: content,
        content: (h) => {
          return h(release, {
            props: { data: params, type: type },
            on: {}
          });
        },
        confirm: (data) => {
          this.release(type, data);
        }
      });
    },

    /**
     * 发布api与下线api
     * @param {Number} type 判断发布与下线
     * @param {Object} params 查询对象
     */
    release(type, params) {
      this.$uxLoading.show();
      let content =
        type === 'release'
          ? this.$t('HT.apiList.publishApi.success')
          : this.$t('HT.apiList.soldOutApi.success');
      this.$api.api[type](params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(content);
          this.getList(this.filter);
        }
      });
    },
    /**
     * 点击搜索
     */
    seach() {
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变分组名称
     */
    change() {
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize() {
      // this.filter.size = size;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage() {
      // this.filter.page = page;
      this.getList(this.filter);
    }
  }
};
</script>
